export type SpeakerProfileField =
  | "fullName"
  | "email"
  | "phone"
  | "organization"
  | "professionalTitle"
  | "bio"
  | "linkedinUrl"
  | "proposedTopic"
  | "consentToContact";

export type SpeakerProfileInput = Record<Exclude<SpeakerProfileField, "consentToContact">, string> & {
  consentToContact: boolean;
};

export type SpeakerProfileErrors = Partial<Record<SpeakerProfileField, string>>;

export const LINKEDIN_PROFILE_URL = /^https:\/\/(?:www\.)?linkedin\.com\/in\/[a-z0-9][a-z0-9-_%]*\/?$/i;

const EMAIL_ADDRESS = /^\S+@\S+\.\S+$/;

/**
 * Mirrors the requiredSpeakerProfile contract in server/routers/speakers.ts so
 * forms can explain invalid fields before a network request is made.
 */
export function validateSpeakerProfile(input: SpeakerProfileInput): SpeakerProfileErrors {
  const errors: SpeakerProfileErrors = {};

  if (input.fullName.trim().length < 2) errors.fullName = "Enter the speaker’s full name.";
  if (!EMAIL_ADDRESS.test(input.email.trim())) errors.email = "Enter a valid email address.";
  if (input.phone.trim().length < 7) errors.phone = "Enter a complete phone number.";
  if (input.organization.trim().length < 2) errors.organization = "Enter an organization.";
  if (input.professionalTitle.trim().length < 2) errors.professionalTitle = "Enter a professional title.";
  if (input.bio.trim().length < 40) errors.bio = "Provide a complete professional biography.";
  if (!LINKEDIN_PROFILE_URL.test(input.linkedinUrl.trim())) {
    errors.linkedinUrl = "Use a public LinkedIn profile URL in the https://www.linkedin.com/in/{profile} format.";
  }
  if (input.proposedTopic.trim().length < 3) errors.proposedTopic = "Enter a talk topic.";
  if (!input.consentToContact) errors.consentToContact = "Consent is required to submit a speaker profile.";

  return errors;
}
